import { inject, Injectable } from '@angular/core';
import { PlayersService } from '../players/players';
import { GameInfoService } from '../games/game-info';

@Injectable({
  providedIn: 'root'
})
export class UnionService {
  players = inject(PlayersService);
  gameInfo = inject(GameInfoService);

  constructor() { }

  unionGamePlayers(uuid: string){
    return [{room: this.gameInfo.getGameInfo(uuid), players: this.players.getPlayersWithGame(uuid)}];
  }
}
